import { render, staticRenderFns } from "./employee-info.vue?vue&type=template&id=121fac58&"
import script from "./employee-info.vue?vue&type=script&lang=js&"
export * from "./employee-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports